<div class="flex flex-col h-full">

    <h2 mat-dialog-title>Importer des sites à partir d'un client existant</h2>
    
    <mat-dialog-content>
        <mat-stepper #stepper>
            <mat-step >
                <div class="flex flex-col h-full">

                    <ng-template matStepLabel>Recherche client</ng-template>
        
                    <div class="mt-2 flex flex-row">
                        <mat-form-field class="w-full">
                            <mat-label>Raison sociale / SIREN / SIRET</mat-label>
                            <input 
                                matInput 
                                placeholder="ACME CORP" 
                                [(ngModel)]="clientNameQuery"
                                (keydown.enter)="searchClient()">
                            <button 
                                mat-icon-button 
                                matSuffix
                                class="mr-2"
                                (click)="searchClient()">
                                <mat-icon>search</mat-icon>
                            </button>
                            
                        </mat-form-field>
                        
                    </div>
                    <ag-grid-angular
                        class="grid-dimensions"
                        [localeText]="gridLocale"
                        [context]="gridContext"
                        [columnDefs]="searchResultColumns"
                        [rowData]="searchResultRowData()"
                        [loadingOverlayComponent]="loadingOverlayComponent"
                        [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                        [getRowId]="getRowId"
                        [autoSizeStrategy]="autoSizeStrategy"
                        [animateRows]="false"
                        (gridReady)="onClientSearchGridReady($event)"
                        (rowDataUpdated)="onClientSearchRowDataUpdated()"
                        (rowDoubleClicked)="selectClient($event.data.id)"
                        />
                </div>
            </mat-step>
            <mat-step>
                <div class="flex flex-col h-full">
                    <ng-template matStepLabel>Choix des sites</ng-template> 
                    <ag-grid-angular
                        class="mt-2 grid-dimensions"
                        [localeText]="gridLocale"
                        [columnDefs]="siteSelectionColumns"
                        [rowData]="siteSelectionRowData()"
                        [loadingOverlayComponent]="loadingOverlayComponent"
                        [loadingOverlayComponentParams]="loadingOverlayComponentParams"
                        [getRowId]="getRowId"
                        [autoSizeStrategy]="autoSizeStrategy"
                        [rowSelection]="{mode: 'multiRow', enableClickSelection: true, enableSelectionWithoutKeys: true}"
                        [rowClass]="'h-full flex items-center'"
                        [animateRows]="false"
                        (gridReady)="onSiteSelectionGridReady($event)"
                        (rowDataUpdated)="onSiteSelectionRowDataUpdated()"
                        (selectionChanged)="onSiteSelectionChanged($event)"
                        />
                </div>
            </mat-step>
        </mat-stepper>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
        <button mat-stroked-button [mat-dialog-close]>Annuler</button>
        <button mat-stroked-button [disabled]="selectedSites().length === 0" (click)="importSites()">
            @if (isImportingSites()) {
                <i class="spinner-btn custom-spinner"></i>
            } @else {
                Importer {{selectedSites().length}} sites
            }
        </button>
    </mat-dialog-actions>
    
    

</div>    

